const pad = (n: number, len = 2) => String(n).padStart(len, "0");

/**
 * Local wall-clock pieces: date `yyyy.mm.dd`, time `HH:mm:ss.SSS`.
 */
export function formatHistoryLocalDateTimeParts(
  timestamp: number | string
): { date: string; time: string } | { date: "Invalid"; time: "Invalid" } {
  try {
    const d = new Date(timestamp);
    if (Number.isNaN(d.getTime())) {
      return { date: "Invalid", time: "Invalid" };
    }
    const date = `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())}`;
    const time = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(d.getMilliseconds(), 3)}`;
    return { date, time };
  } catch {
    return { date: "Invalid", time: "Invalid" };
  }
}

/** Single string `yyyy.mm.dd HH:mm:ss.SSS` in local time, or `—` if invalid. */
export function formatHistoryLocalDateTime(
  timestamp: number | string | null | undefined
): string {
  if (timestamp === null || timestamp === undefined) return "—";
  const parts = formatHistoryLocalDateTimeParts(timestamp);
  if (parts.date === "Invalid") return "—";
  return `${parts.date} ${parts.time}`;
}

/** Same as formatHistoryLocalDateTime but treats non-finite or non-positive ms as missing. */
export function formatHistoryLocalDateTimeMs(ms: number): string {
  if (!Number.isFinite(ms) || ms <= 0) return "—";
  return formatHistoryLocalDateTime(ms);
}
